import { render, staticRenderFns } from "./Flashcard.vue?vue&type=template&id=119b6f46&scoped=true&"
import script from "./Flashcard.vue?vue&type=script&lang=js&"
export * from "./Flashcard.vue?vue&type=script&lang=js&"
import style0 from "./Flashcard.vue?vue&type=style&index=0&id=119b6f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b6f46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow,VSpacer})
